import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/assets/images/icons/i-icon.png'


const _hoisted_1 = { class: "vechile-details-list" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "label-block" }
const _hoisted_4 = { class: "label-block_label" }
const _hoisted_5 = { class: "label-block_question position-relative" }
const _hoisted_6 = { class: "tooltip-content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_8 = { class: "input-block" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-10" }
const _hoisted_11 = { class: "country-select" }
const _hoisted_12 = { class: "d-flex align-items-center mb-3" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "d-block ms-4" }
const _hoisted_15 = { class: "d-flex align-items-center mb-3" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "d-block ms-4" }
const _hoisted_18 = { class: "form-block" }
const _hoisted_19 = { class: "label-block" }
const _hoisted_20 = { class: "label-block_label" }
const _hoisted_21 = { class: "label-block_question position-relative" }
const _hoisted_22 = { class: "tooltip-content" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_24 = { class: "input-block" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-lg-10" }
const _hoisted_27 = { class: "d-flex align-items-center mb-3" }
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "d-block ms-4" }
const _hoisted_30 = { class: "d-flex align-items-center mb-3" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "d-block ms-4" }
const _hoisted_33 = { class: "form-block" }
const _hoisted_34 = { class: "label-block" }
const _hoisted_35 = { class: "label-block_label px-0" }
const _hoisted_36 = { class: "input-block" }
const _hoisted_37 = { class: "checkbox-row" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "d-block" }
const _hoisted_41 = { class: "form-block" }
const _hoisted_42 = { class: "label-block" }
const _hoisted_43 = { class: "label-block_label" }
const _hoisted_44 = { class: "label-block_question position-relative" }
const _hoisted_45 = { class: "tooltip-content" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_47 = { class: "input-block" }
const _hoisted_48 = { class: "checkbox-row" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "d-block" }
const _hoisted_52 = { class: "form-block claims-block-container" }
const _hoisted_53 = { class: "label-block mb-0" }
const _hoisted_54 = { class: "d-flex justify-content-between w-100 switch-container claims-block" }
const _hoisted_55 = { class: "label-block_label" }
const _hoisted_56 = { class: "switch-toggle" }
const _hoisted_57 = { for: "a" }
const _hoisted_58 = {
  key: 0,
  class: "switch-toggle__switch",
  "data-checked": "لا",
  "data-unchecked": "نعم"
}
const _hoisted_59 = {
  key: 1,
  class: "switch-toggle__switch",
  "data-checked": "No",
  "data-unchecked": "Yes"
}
const _hoisted_60 = { class: "label-block_question position-relative" }
const _hoisted_61 = { class: "tooltip-content" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_63 = {
  key: 1,
  class: "form-block"
}
const _hoisted_64 = { class: "label-block" }
const _hoisted_65 = { class: "label-block_label" }
const _hoisted_66 = { class: "label-block_question position-relative" }
const _hoisted_67 = { class: "tooltip-content" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("a", {
  class: "popper",
  "data-bs-trigger": "hover",
  placement: "right",
  "data-bs-toggle": "popover"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "icon-question-icon" })
  ])
], -1)
const _hoisted_69 = { class: "input-block" }
const _hoisted_70 = { class: "row" }
const _hoisted_71 = { class: "col-lg-10" }
const _hoisted_72 = {
  key: 2,
  class: "form-block"
}
const _hoisted_73 = { class: "label-block" }
const _hoisted_74 = { class: "label-block_label" }
const _hoisted_75 = { class: "input-block" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-lg-10" }
const _hoisted_78 = { class: "form-block" }
const _hoisted_79 = { class: "form-title" }
const _hoisted_80 = { class: "mb-0" }
const _hoisted_81 = { class: "form-block confirm-details" }
const _hoisted_82 = { class: "label-block mb-0" }
const _hoisted_83 = { class: "d-flex justify-content-between w-100 switch-container" }
const _hoisted_84 = { class: "label-block_label" }
const _hoisted_85 = { class: "switch-toggle" }
const _hoisted_86 = { for: "b" }
const _hoisted_87 = {
  key: 0,
  class: "switch-toggle__switch",
  "data-checked": "لا",
  "data-unchecked": "نعم"
}
const _hoisted_88 = {
  key: 1,
  class: "switch-toggle__switch",
  "data-checked": "No",
  "data-unchecked": "Yes"
}
const _hoisted_89 = { class: "form-block confirm-details" }
const _hoisted_90 = { class: "label-block mb-0" }
const _hoisted_91 = { class: "d-flex justify-content-between w-100 switch-container" }
const _hoisted_92 = { class: "label-block_label" }
const _hoisted_93 = { class: "switch-toggle" }
const _hoisted_94 = { for: "c" }
const _hoisted_95 = {
  key: 0,
  class: "switch-toggle__switch",
  "data-checked": "لا",
  "data-unchecked": "نعم"
}
const _hoisted_96 = {
  key: 1,
  class: "switch-toggle__switch",
  "data-checked": "No",
  "data-unchecked": "Yes"
}
const _hoisted_97 = { class: "form-block confirm-details" }
const _hoisted_98 = { class: "label-block mb-0" }
const _hoisted_99 = { class: "d-flex justify-content-between w-100 switch-container" }
const _hoisted_100 = { class: "label-block_label" }
const _hoisted_101 = { class: "switch-toggle" }
const _hoisted_102 = { for: "d" }
const _hoisted_103 = {
  key: 0,
  class: "switch-toggle__switch",
  "data-checked": "لا",
  "data-unchecked": "نعم"
}
const _hoisted_104 = {
  key: 1,
  class: "switch-toggle__switch",
  "data-checked": "No",
  "data-unchecked": "Yes"
}
const _hoisted_105 = { class: "form-block confirm-details" }
const _hoisted_106 = { class: "label-block mb-0" }
const _hoisted_107 = { class: "d-flex justify-content-between w-100 switch-container" }
const _hoisted_108 = { class: "label-block_label" }
const _hoisted_109 = { class: "switch-toggle" }
const _hoisted_110 = { for: "e" }
const _hoisted_111 = {
  key: 0,
  class: "switch-toggle__switch",
  "data-checked": "لا",
  "data-unchecked": "نعم"
}
const _hoisted_112 = {
  key: 1,
  class: "switch-toggle__switch",
  "data-checked": "No",
  "data-unchecked": "Yes"
}
const _hoisted_113 = { class: "note-row" }
const _hoisted_114 = { class: "note-block bg-white position-relative" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid"
  })
], -1)
const _hoisted_116 = { class: "submit-btn ps-0 text-md-end text-center" }
const _hoisted_117 = { class: "row" }
const _hoisted_118 = { class: "col-lg-10" }
const _hoisted_119 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vc_date_picker = _resolveComponent("vc-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "ruleFormRef",
    model: _ctx.driver,
    "status-icon": "",
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_vc_date_picker, {
          isRequired: "",
          "model-value": _ctx.driver.dob,
          "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.driver.dob) = $event)),
          "is-tooltip": "",
          "tooltip-message": _ctx.$t('dob'),
          "form-prop": "dob",
          label: _ctx.$t('date_of_birth'),
          ref: "dob",
          max: _ctx.dobMaxDate,
          default: _ctx.dobMaxDate
        }, null, 8, ["model-value", "tooltip-message", "label", "max", "default"]),
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.nationality_ids)
                ? (_openBlock(), _createBlock(_Teleport, {
                    key: 0,
                    to: `#${_ctx.nationality_ids}`
                  }, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.nationality_search,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nationality_search) = $event)),
                      placeholder: "Search ..",
                      ref: "nationality_search_ref",
                      style: {"position":"absolute","top":"0px"}
                    }, null, 8, ["modelValue"])
                  ], 8, ["to"]))
                : _createCommentVNode("", true),
              (_ctx.country_ids)
                ? (_openBlock(), _createBlock(_Teleport, {
                    key: 1,
                    to: `#${_ctx.country_ids}`
                  }, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.country_search,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.country_search) = $event)),
                      placeholder: "Search ..",
                      ref: "country_search_ref",
                      style: {"position":"absolute","top":"0px"}
                    }, null, 8, ["modelValue"])
                  ], 8, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", { ref: "nation" }, _toDisplayString(_ctx.$t('nationality')) + " * ", 513)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('nationality_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_form_item, { prop: "nationality" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.driver.nationality,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.driver.nationality) = $event)),
                        filterable: !_ctx.isMobile,
                        placeholder: _ctx.language === 'ar' ? 'الجنسية' : 'Nationality',
                        class: "select-input",
                        onChange: _ctx.selectedNationality,
                        "popper-class": {'nationality_teleport': _ctx.isMobile},
                        onClick: _ctx.alertNationality
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isMobile)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_nationality, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: _ctx.language === 'ar' ? item.label_ar : item.label,
                                  value: item.value,
                                  class: "country-list-item"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createVNode(_component_el_avatar, {
                                        size: 40,
                                        class: "d-block"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: `/img/flags/${item.code.toLowerCase()}.svg`
                                          }, null, 8, _hoisted_13)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.language === 'ar' ? item.label_ar : item.label), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (!_ctx.isMobile)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.nationalities, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: index,
                                  label: _ctx.language === 'ar' ? item.label_ar : item.label,
                                  value: item.value,
                                  class: "country-list-item"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createVNode(_component_el_avatar, {
                                        size: 40,
                                        class: "d-block"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("img", {
                                            src: `/img/flags/${item.code.toLowerCase()}.svg`
                                          }, null, 8, _hoisted_16)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.language === 'ar' ? item.label_ar : item.label), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "filterable", "placeholder", "onChange", "popper-class", "onClick"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", { ref: "country" }, _toDisplayString(_ctx.$t('first_driving_license')) + " * ", 513)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('first_driving_license_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_el_form_item, { prop: "first_driving_license_country" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.driver.first_driving_license_country,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.driver.first_driving_license_country) = $event)),
                      filterable: !_ctx.isMobile,
                      placeholder: _ctx.language === 'ar' ? 'البلد' : 'Country',
                      class: "select-input",
                      "popper-class": {'country_teleport': _ctx.isMobile},
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.country_search = '')),
                      onClick: _ctx.alertCountry
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.filtered_country, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: _ctx.language === 'ar' ? item.label_ar : item.label,
                                value: item.value,
                                class: "country-list-item"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createVNode(_component_el_avatar, {
                                      size: 40,
                                      class: "d-block"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: `/img/flags/${item.code.toLowerCase()}.svg`
                                        }, null, 8, _hoisted_28)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.language === 'ar' ? item.label_ar : item.label), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true),
                        (!_ctx.isMobile)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.nationalities, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: _ctx.language === 'ar' ? item.label_ar : item.label,
                                value: item.value,
                                class: "country-list-item"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_el_avatar, {
                                      size: 40,
                                      class: "d-block"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("img", {
                                          src: `/img/flags/${item.code.toLowerCase()}.svg`
                                        }, null, 8, _hoisted_31)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.language === 'ar' ? item.label_ar : item.label), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "filterable", "placeholder", "popper-class", "onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createVNode(_component_vc_date_picker, {
          isRequired: "",
          "model-value": _ctx.driver.first_registration_date,
          "onUpdate:model-value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.driver.first_registration_date) = $event)),
          "form-prop": "first_registration_date",
          label: _ctx.$t('first_registration_date'),
          ref: "first_registration_date",
          min: _ctx.firstRegistrationMinDate,
          max: _ctx.firstRegistrationMaxDate
        }, null, 8, ["model-value", "label", "min", "max"]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('home_country_driving_experience')) + " *", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drivingExperiences, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-lg-3 col-md-6 col-6 col-sm-4",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`checkbox-big ${_ctx.driver.driving_experience == item.value ? 'active' : ''}`),
                      onClick: ($event: any) => (_ctx.changeDrivingExperience(item.value))
                    }, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                        _createElementVNode("span", _hoisted_40, _toDisplayString(item.block), 1)
                      ])
                    ], 10, _hoisted_39)
                  ]))
                }), 128)),
                _createVNode(_component_el_form_item, { prop: "driving_experience" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "hidden",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.driver.driving_experience) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.driver.driving_experience]
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('uae_driving_experience')) + " *", 1)
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t('uae_driving_experience_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_46
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drivingExperiences, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-lg-3 col-md-6 col-6 col-sm-4",
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`checkbox-big ${_ctx.driver.uae_driving_experience == item.value ? 'active' : ''}`),
                      onClick: ($event: any) => (_ctx.changeUaeDrivingExperience(item.value))
                    }, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                        _createElementVNode("span", _hoisted_51, _toDisplayString(item.block), 1)
                      ])
                    ], 10, _hoisted_50)
                  ]))
                }), 128)),
                _createVNode(_component_el_form_item, { prop: "uae_driving_experience" })
              ])
            ])
          ])
        ]),
        _createVNode(_component_vc_date_picker, {
          isRequired: "",
          "model-value": _ctx.driver.policy_start_date,
          "onUpdate:model-value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.driver.policy_start_date) = $event)),
          "is-tooltip": "",
          "tooltip-message": _ctx.$t('policy_start_date_tool_tip'),
          "form-prop": "policy_start_date",
          label: _ctx.$t('policy_start_date'),
          ref: "policy_start_date",
          min: _ctx.todayDate,
          max: _ctx.policyStartMaxDate
        }, null, 8, ["model-value", "tooltip-message", "label", "min", "max"]),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('claims_with_your_insurance')), 1)
              ]),
              _createElementVNode("div", _hoisted_56, [
                _withDirectives(_createElementVNode("input", {
                  id: "a",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.claimed_insurance) = $event)),
                  onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleClaimedInsurance && _ctx.handleClaimedInsurance(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.claimed_insurance]
                ]),
                _createElementVNode("label", _hoisted_57, [
                  (_ctx.language === 'ar')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58))
                    : (_openBlock(), _createElementBlock("div", _hoisted_59))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_component_el_tooltip, {
                class: "box-item",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("p", _hoisted_61, _toDisplayString(_ctx.$t('claims_with_your_insurance_tool_tip')), 1)
                ]),
                default: _withCtx(() => [
                  _hoisted_62
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (_ctx.claimed_insurance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("label", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('no_claims')) + " ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('no_claims_save')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "light"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t('no_claims_tool_tip')), 1)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_68
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createVNode(_component_el_form_item, { prop: "no_claim_certificate" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.driver.no_claim_certificate,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.driver.no_claim_certificate) = $event)),
                          filterable: "",
                          placeholder: "Day",
                          class: "select-input"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noClaimCertificates, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.claimed_insurance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("label", null, _toDisplayString(_ctx.$t('no_claim_certificate')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createVNode(_component_el_form_item, { prop: "claims" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.driver.claims,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.driver.claims) = $event)),
                          modelModifiers: { number: true },
                          type: "number",
                          min: 1
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("h3", _hoisted_80, _toDisplayString(_ctx.$t('confirm_details')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('gcc_specification')), 1)
              ]),
              _createElementVNode("div", _hoisted_85, [
                _withDirectives(_createElementVNode("input", {
                  id: "b",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.gcc_specification) = $event)),
                  onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.handleGccSpecification && _ctx.handleGccSpecification(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.gcc_specification]
                ]),
                _createElementVNode("label", _hoisted_86, [
                  (_ctx.language === 'ar')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_87))
                    : (_openBlock(), _createElementBlock("div", _hoisted_88))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('car_personal_use')), 1)
              ]),
              _createElementVNode("div", _hoisted_93, [
                _withDirectives(_createElementVNode("input", {
                  id: "c",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.personal_use) = $event)),
                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handlePersonalUse && _ctx.handlePersonalUse(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.personal_use]
                ]),
                _createElementVNode("label", _hoisted_94, [
                  (_ctx.language === 'ar')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_95))
                    : (_openBlock(), _createElementBlock("div", _hoisted_96))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_97, [
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('is_current_policy_active')), 1)
              ]),
              _createElementVNode("div", _hoisted_101, [
                _withDirectives(_createElementVNode("input", {
                  id: "d",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.current_policy_active) = $event)),
                  onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.changePolicyExpired && _ctx.changePolicyExpired(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.current_policy_active]
                ]),
                _createElementVNode("label", _hoisted_102, [
                  (_ctx.language === 'ar')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103))
                    : (_openBlock(), _createElementBlock("div", _hoisted_104))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_105, [
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("div", _hoisted_108, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t('is_current_policy_comprehensive')), 1)
              ]),
              _createElementVNode("div", _hoisted_109, [
                _withDirectives(_createElementVNode("input", {
                  id: "e",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.fully_comprehensive) = $event)),
                  onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.changeThirdPartyLiability && _ctx.changeThirdPartyLiability(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.fully_comprehensive]
                ]),
                _createElementVNode("label", _hoisted_110, [
                  (_ctx.language === 'ar')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_111))
                    : (_openBlock(), _createElementBlock("div", _hoisted_112))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_113, [
        _createElementVNode("div", _hoisted_114, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('bottom_float')), 1),
          _hoisted_115
        ]),
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("div", _hoisted_118, [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "primary",
                class: "btn",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleClick(_ctx.ruleFormRef))),
                "element-loading-background": "rgba(0, 0, 0, 0.4)",
                disabled: _ctx.isClick
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_119, _toDisplayString(_ctx.$t('proceed')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])), [
                [
                  _directive_loading,
                  _ctx.isClick,
                  void 0,
                  {
                    fullscreen: true,
                    lock: true
                  }
                ]
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}